module.exports = __webpack_public_path__ + "img/calendar.55fd84d9.svg";